import React, { useState, useEffect } from 'react'
import useThrottleFn from 'react-use/lib/useThrottleFn'

import { ArrowUpIcon } from 'components/common'

import s from './ScrollToTop.module.css'

const ScrollToTop = ({ pageOffset }) => {
  const [isVisible, setIsVisible] = useState(false)
  const throttledValue = useThrottleFn((pageOffset) => pageOffset, 1000, [
    pageOffset
  ])

  useEffect(() => {
    if (pageOffset > 500) setIsVisible(true)
    else {
      setIsVisible(false)
    }
  }, [throttledValue])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!isVisible) {
    return false
  }

  return (
    <button className={s.scrollBtn} onClick={scrollToTop}>
      <ArrowUpIcon className={s.arrow} />
    </button>
  )
}

export default ScrollToTop
